module.exports = __webpack_public_path__ + "static/media/logo-chaval.625d4ee5.png";